import { memo as Memo } from 'react';

//* Components
import Tag from '../Tag';
import Text from '@components/global/Text';
// import Wave from '@components/global/SvgComponents/WaveSvg'

const TagCheckbox = Memo((props) => {
	return (
		<Tag
			type='oval'
			className={`tag-checkbox ${props.checked ? 'checked' : ''}`}>
			<input
				type='checkbox'
				name={props.label}
				onChange={() => props.onChange && props.onChange(props.value)}
				checked={props.checked}
			/>

			<Text
				tag={'label'}
				text={props.label}
				className={`tag-checkbox-name`}
				onClick={() => props.onChange && props.onChange(props.value)}
			/>

			{/* <Wave animate={props.checked}/> */}
		</Tag>
	);
});

export default TagCheckbox;
